import PageState from "./state"
import mutations from "./mutations"
import {getModule} from '@/store/store'
let APIS = {
  // queryDouYinUser:`/apis/moyin-account/moyou/activity/queryDouYinUser`,
  queryDouYinUser:`/apis/moyin-account/moyou/activity/bindAccountList`,
  //获取当前活动
  queryCurrentActivity:`/apis/moyin-account/moyou/activity/queryCurrentActivity`,
}
export default {
  ...getModule({
    state:new PageState(),
    mutations,
    actions:{},
    APIS,
    name:"activity"
  })
}